// src/shared/hooks/useSyncLightMode.tsx

import { useEffect } from 'react';
import { useUserSettingsStore } from '@/domains/user/userSettings.store';

export function useSyncLightMode() {
  const { settings } = useUserSettingsStore();
  const { light_mode } = settings;

  useEffect(() => {
    if (light_mode === 'system') {
      const systemMode = window.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? 'dark'
        : 'light';
      document.documentElement.classList.add(systemMode);
      document.documentElement.setAttribute('data-mode', systemMode);

      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      const handleSystemChange = (e: MediaQueryListEvent) => {
        const newMode = e.matches ? 'dark' : 'light';
        document.documentElement.classList.remove('dark', 'light');
        document.documentElement.classList.add(newMode);
        document.documentElement.setAttribute('data-mode', newMode);
      };

      mediaQuery.addEventListener('change', handleSystemChange);

      return () => {
        mediaQuery.removeEventListener('change', handleSystemChange);
      };
    } else {
      document.documentElement.classList.remove('dark', 'light');
      document.documentElement.classList.add(light_mode);
      document.documentElement.setAttribute('data-mode', light_mode);

      return () => {
        document.documentElement.classList.remove(light_mode);
        document.documentElement.removeAttribute('data-mode');
      };
    }
  }, [light_mode]);
}
